import React from 'react';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';

export const CoverageForFilter = ({
  coverageFor: options,
  activeCoverage: selectedValue,
  coverageChangeHandler: onChange,
}) => {
  //const currentSelection = selectedValue!== undefined ?  options.filter( ( sel ) => sel.value === selectedValue.value ):[];
  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="coverage-for-filter height-32 view-member"
      value={selectedValue}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
